interface Props {
  points: number[];
  width?: number;
  height?: number;
  className?: string;
}

// Lightweight SVG sparkline for game cards. Color shifts to rose-700 when the
// last point is below the first (price drop) and gray when flat/rising.
export function MiniSparkline({
  points,
  width = 88,
  height = 24,
  className = "",
}: Props) {
  if (points.length < 2) return null;

  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;

  // Inset vertically so dots at min/max don't get clipped at the edges.
  const padY = 2;
  const usableH = height - padY * 2;
  const padX = 2;
  const usableW = width - padX * 2;

  const xs = points.map((_, i) => padX + (i / (points.length - 1)) * usableW);
  const ys = points.map((p) => padY + usableH - ((p - min) / span) * usableH);

  const d = points
    .map((_, i) => `${i === 0 ? "M" : "L"}${xs[i].toFixed(1)} ${ys[i].toFixed(1)}`)
    .join(" ");

  const dropped = points[points.length - 1] < points[0];
  const stroke = dropped ? "#9f1239" : "#a3a3a3";
  // Shrink dots when there are many points so they don't merge into a blob.
  const dotR = points.length > 20 ? 1.2 : 1.6;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      aria-hidden
    >
      <path
        d={d}
        fill="none"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {points.map((_, i) => (
        <circle
          key={i}
          cx={xs[i].toFixed(1)}
          cy={ys[i].toFixed(1)}
          r={dotR}
          fill="#fff"
          stroke={stroke}
          strokeWidth={1}
        />
      ))}
    </svg>
  );
}
